import * as actionTypes from './actionTypes'

export const setLoadingInit = loading => ({
    type: actionTypes.LOADING_INIT,
    payload: { loading },
})

export const setLoading = loading => ({
    type: actionTypes.LOADING,
    payload: { loading },
})

export const resetLoading = () => ({
    type: actionTypes.RESET_LOADING,
})

export const toggleLoginForm = isOpen => ({
    type: actionTypes.SHOW_LOGIN,
    payload: { isOpen },
})

export const setLastActive = payload => ({
    type: actionTypes.SET_LAST_ACTIVE,
    payload,
})

export const setAgreeOvertime = payload => ({
    type: actionTypes.AGREE_OVERTIME,
    payload,
})
